import React, { useState } from "react";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import SectorNameField from "./SectorNameField";
import { getSectorByName, saveSector } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import * as ruleService from "../../../ruleService";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function CreateSectorModal({ setShowModal, validationErrors, onBack }) {

    const [sector, setSector] = useState({});

    const onSaveClick = async () => {

        const serverSector = await getSectorByName(sector.name);
        let savedSector;

        if (serverSector.error && serverSector.statusCode === 404) {
            savedSector = await saveSector(sector);
        } else {
            showDangerToast(`Sector with name '${sector.name}' already exist`, "Save Sector")
        }

        if (savedSector) {
            showSuccessToast("Sector created", "Save Sector");
            ruleService.loadRuleTargetTypes({ includeAllMsbs: true }).then(() => setShowModal(false));
        }

    }

    return (
        <TargetTypeWizardModal
            title="Add Sector Wizard"
            subtitle="Create a sector target type."
            onClose={() => setShowModal(false)}
            onBack={onBack}
            onSubmit={onSaveClick}
            submitLabel="Save"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <SectorNameField sector={sector} setSector={setSector} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(CreateSectorModal);
